import Interface from './Interface';

class LocalStorage extends Interface {
    get(key) {
        return localStorage.getItem(key) || null;
    }

    set(key, value) {
        return localStorage.setItem(key, value);
    }

    remove(key) {
        return localStorage.removeItem(key);
    }

  clear() {
    return localStorage.clear();
  }
}

export default LocalStorage;


// WEBPACK FOOTER //
// ./src/common/auth/storage/drivers/LocalStorage.js